import { useState, useEffect } from "react";
import { useGetCenterTransfersQuery, useRevertTransferMutation } from "../api/studentTransferApi";
import { showToast } from "../../../../core/utils/alert";
import { getApiErrorMessage } from "../../../../core/utils/errorHandler";
import { useSelector } from "react-redux";
import { selectUserRole, selectCurrentUser } from "../../../../core/data/slice/authSlice";

export const useStudentTransfers = () => {
  const [transferType, setTransferType] = useState<"incoming" | "outgoing" | "all">(() => {
    try {
      const saved = sessionStorage.getItem("studentTransfers_transferType");
      return (saved as "incoming" | "outgoing" | "all") || "outgoing";
    } catch {
      return "outgoing";
    }
  });

  const [centerId, setCenterId] = useState<string | undefined>(() => {
    try {
      const saved = sessionStorage.getItem("studentTransfers_centerId");
      return saved || undefined;
    } catch {
      return undefined;
    }
  });

  useEffect(() => {
    sessionStorage.setItem("studentTransfers_transferType", transferType);
  }, [transferType]);

  useEffect(() => {
    if (centerId) {
      sessionStorage.setItem("studentTransfers_centerId", centerId);
    } else {
      sessionStorage.removeItem("studentTransfers_centerId");
    }
  }, [centerId]);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  
  const userRole = useSelector(selectUserRole);
  const currentUser = useSelector(selectCurrentUser);

  const { data, isLoading, isError, error, isFetching } = useGetCenterTransfersQuery({
    transferType,
    center_id: centerId,
    page,
    size,
  }, {
    skip: userRole === "superadmin" && !centerId
  });

  const [revertTransferMutation, { isLoading: isReverting }] = useRevertTransferMutation();

  const handleRevert = async (transferId: number) => {
    try {
      await revertTransferMutation(transferId).unwrap();
      showToast({ icon: "success", text: "Transfer reverted successfully" });
    } catch (err) {
      showToast({ icon: "error", text: getApiErrorMessage(err) });
    }
  };

  const transfers = data?.data?.student_transfers || [];
  const totalItems = data?.data?.totalItems || 0;

  return {
    transferType,
    setTransferType,
    centerId,
    setCenterId,
    page,
    setPage,
    size,
    setSize,
    transfers,
    totalItems,
    isLoading,
    isFetching,
    isError,
    error,
    handleRevert,
    isReverting,
    userRole,
    currentUser,
  };
};
